import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { httpClient } from '../../../../../core/infra/http/apolo-http-client-adapter';
import { AUTH_API_ROUTES } from '../../api/routes';
import { ConfirmEmailCode } from './confirm-email-code';

export const confirmEmailCodeService: ServiceCommand<ConfirmEmailCode.Response> =
  new ConfirmEmailCode(httpClient, AUTH_API_ROUTES.CONFIRM_EMAIL_CODE);

export type { ConfirmEmailCode };
